export default __webpack_public_path__ + "static/media/team-what-we-need-icon.9c05c5a0.svg";